import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Z9() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div id="dual-fast" className={`d2x-Z9 ${css.d2xZ9} GtmModuleData-section`} data-section-id={css.d2xZ9} data-section-title={t('sec9_title')}>
            <div className="sec9">
                <div className="text-box">
                    <p className="subtitle">{t('sec9_subtitle')}</p>
                    <p className="title">{t('sec9_title')}</p>
                    <p className="desc">{t('sec9_short_desc')}</p>
                </div>
                <div className="video-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z9.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z9.jpg')}
                        alt={t('sec9_title')}
                        aria-label={t('sec9_title')}
                    />
                </div>
                <p className="tips">{t('sec9_tips')}</p>
            </div>
        </div>
    );
}
